import { Link } from 'react-router-dom';

/** Route: `*`. 404 fallback with links back to dashboard and docs. */
export function NotFoundPage() {
  return (
    <div className="public-shell">
      <div className="brand">
        <h1>AstdZ<span style={{ color: 'var(--color-accent)' }}>_</span></h1>
        <div className="tag">404 not found</div>
      </div>
      <div className="ascii-rule">━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━</div>
      <div className="panel">
        <p className="text-muted" style={{ marginBottom: 16 }}>
          the requested page does not exist.
        </p>
        <p>
          <Link to="/dashboard">→ return to dashboard</Link>
        </p>
        <p>
          <Link to="/docs">→ documentation</Link>
        </p>
      </div>
      <div className="ascii-rule">━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━</div>
    </div>
  );
}
